import styled from 'styled-components';

export const UiBookListPage = styled.div`
	display: flex;
	justify-content: center;
`;
